import { Outlet } from "react-router";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { AlertNotReleased } from "@/shared/components/alerts/alert-not-released";

export function OffersRoute() {
  const isReleased = useBooleanFlagValue("gsm.omni.offers", true);
  if (!isReleased) {
    return <AlertNotReleased />;
  }

  return <Outlet />;
}
